import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./About.css"; // Ensure you import your CSS file

const About = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="row position-relative">
          <div
            className="col-lg-7 about-img"
            data-aos="zoom-out"
            data-aos-delay="200"
          >
            <img src="/assets/img/m-mission/mission-about.png" alt="About Us" />
          </div>

          <div className="col-lg-7" data-aos="fade-up" data-aos-delay="100">
            <h2 className="inner-title custom-title">
              Transforming Conversations into Impact
            </h2>
            <div className="our-story">
              <h4>Est 2017</h4>
              <h3>Our Story</h3>
              <p>
                In our youth, we often found ourselves gathered at the local
                'Parar More Adda' (neighborhood corner) and 'Cha er Dokan' (tea
                stall), engaging in casual conversations and enjoying each
                other's company. However, everything changed in 2017 when our
                community faced a devastating crisis due to severe flooding in
                the Malda district. The Phulhar River reached alarming levels,
                inundating numerous villages and forcing residents to evacuate
                their homes in search of higher ground.
              </p>
              <p>
                The widespread suffering and despair that enveloped the district
                prompted us—Anirban, Susanta, Prasenjit, Krittibas, Sanjoy,
                Kartick, Saikat, and Soumen—to reassess our priorities. We
                recognized that it was no longer sufficient to spend our time in
                idle chatter; instead, we felt a profound responsibility to
                assist those in need. This pivotal moment galvanized us to
                channel our energy into meaningful, constructive efforts aimed
                at alleviating the hardships faced by our fellow community
                members.
              </p>

              <div className="image-gallery">
                <img
                  src="/assets/img/m-mission/Our_Story.jpg"
                  alt="Image 1"
                  className="responsive-image"
                />
              </div>

              <div className="watch-video d-flex align-items-center position-relative">
                <i className="bi bi-play-circle"></i>
                <a
                  href="https://www.youtube.com/watch?v=_nqe4vaExCY"
                  className="glightbox stretched-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Watch Video
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
